import { render } from "./DropdownMenu.vue?vue&type=template&id=628d4c3e&scoped=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=628d4c3e&scoped=true&lang=css"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628d4c3e"]])

export default __exports__